/**
 * Shopify Auto Cart - Versão V9 (Otimizada para Automação e Percepção do Cliente)
 *
 * MELHORIAS DESTA VERSÃO:
 * 1. INSERÇÃO E REMOÇÃO AUTOMÁTICA: O script agora gerencia a adição e remoção de brindes
 *    em tempo real com base no valor do subtotal.
 * 2. PERCEPÇÃO DO CLIENTE: Notificações visuais imediatas para adições e remoções.
 * 3. INTERCEPTAÇÃO DE REQUISIÇÕES (Fetch/XHR): Monitora chamadas de API do Shopify (add.js, change.js, update.js)
 *    para reagir instantaneamente a qualquer alteração no carrinho.
 * 4. SINCRONIZAÇÃO DE UI: Dispara eventos padrão do Shopify para garantir que o mini-cart ou
 *    página de carrinho se atualize sem recarregar a página.
 */

(function() {
  'use strict';

  const CONFIG = {
    GIFTS: [       
      { THRESHOLD: 149.00, PRODUCT_VARIANT_ID: 47532462866587, NAME: "🎁 Fattore Tratamento 12 Em 1 Máscara Reconstrução 150ml (Brinde)" },
    ],
    NOTIFICATION: { ENABLED: true, DURATION: 4000 },
    OPTIMIZATION: {
      DEBOUNCE_DELAY: 500, // Reduzido para resposta mais rápida
      COOLDOWN_AFTER_ACTION: 1000 
    },
    DEBUG: false
  };

  let isProcessing = false;
  let cooldownUntil = 0;
  let debounceTimeout = null;
  let lastProcessedCartHex = '';

  function log(...args) { if (CONFIG.DEBUG) console.log('[AutoCart V9]', ...args); }

  function isInCooldown() { return Date.now() < cooldownUntil; }

  function refreshCartUI(cart) {
    log('Sincronizando interface do tema...');
    const events = ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'cart:change', 'shopify:cart:updated'];
    events.forEach(evt => {
      document.dispatchEvent(new CustomEvent(evt, { bubbles: true, detail: cart }));
    });
    
    // Suporte específico para temas que usam a API de Seções do Shopify
    if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) {
        Shopify.PaymentButton.init();
    }
  }

  function showNotification(message, type = 'success') {
    if (!CONFIG.NOTIFICATION.ENABLED) return;
    let container = document.getElementById('auto-cart-notifications') || (function() {
      const c = document.createElement('div');
      c.id = 'auto-cart-notifications';
      c.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 1000000; pointer-events: none;';
      document.body.appendChild(c);
      return c;
    })();

    const notification = document.createElement('div');
    const bgColor = type === 'success' ? '#28a745' : '#dc3545';
    notification.style.cssText = `background: ${bgColor}; color: white; padding: 12px 20px; margin-bottom: 8px; border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-family: sans-serif; font-weight: 500; transform: translateX(120%); transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94); pointer-events: auto;`;
    notification.textContent = message;
    container.appendChild(notification);

    setTimeout(() => notification.style.transform = 'translateX(0)', 50);
    setTimeout(() => {
      notification.style.transform = 'translateX(120%)';
      setTimeout(() => notification.remove(), 400);
    }, CONFIG.NOTIFICATION.DURATION);
  }

  async function checkCart() {
    if (isProcessing || isInCooldown()) return;
    
    isProcessing = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
      const cart = await response.json();

      const currentCartHex = cart.items.map(i => `${i.variant_id}:${i.quantity}`).join('|') + cart.total_price;
      if (currentCartHex === lastProcessedCartHex) {
        isProcessing = false;
        return;
      }

      const giftIds = new Set(CONFIG.GIFTS.map(g => g.PRODUCT_VARIANT_ID));
      let subtotal = 0;
      let hasNormalItems = false;
      const currentGifts = new Map();

      cart.items.forEach(item => {
        if (giftIds.has(item.variant_id)) {
          currentGifts.set(item.variant_id, item.quantity);
        } else {
          subtotal += item.final_line_price;
          hasNormalItems = true;
        }
      });

      // Se o carrinho só tiver brindes, limpa tudo
      if (cart.item_count > 0 && !hasNormalItems) {
        await fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' });
        lastProcessedCartHex = '';
        window.location.reload();
        return;
      }

      subtotal /= 100;
      const updates = {};
      const addedGifts = [];
      const removedGifts = [];

      CONFIG.GIFTS.forEach(gift => {
        const qty = currentGifts.get(gift.PRODUCT_VARIANT_ID) || 0;
        const eligible = subtotal >= gift.THRESHOLD;

        if (eligible && qty !== 1) {
          updates[gift.PRODUCT_VARIANT_ID] = 1;
          addedGifts.push(gift.NAME);
        } else if (!eligible && qty > 0) {
          updates[gift.PRODUCT_VARIANT_ID] = 0;
          removedGifts.push(gift.NAME);
        }
      });

      if (Object.keys(updates).length > 0) {
        log('Aplicando correções de brindes...', updates);
        const upResp = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        const newCart = await upResp.json();
        
        lastProcessedCartHex = newCart.items.map(i => `${i.variant_id}:${i.quantity}`).join('|') + newCart.total_price;
        cooldownUntil = Date.now() + CONFIG.OPTIMIZATION.COOLDOWN_AFTER_ACTION;
        
        refreshCartUI(newCart);
        addedGifts.forEach(name => showNotification(`${name} adicionado!`, 'success'));
        removedGifts.forEach(name => showNotification(`${name} removido (valor mínimo não atingido).`, 'error'));
      } else {
        lastProcessedCartHex = currentCartHex;
      }

      // Esconder seletores de quantidade para brindes
      hideGiftQuantities();

    } catch (e) {
      log('Erro:', e);
    } finally {
      isProcessing = false;
    }
  }

  function hideGiftQuantities() {
    CONFIG.GIFTS.forEach(gift => {
      document.querySelectorAll(`[href*="/variants/${gift.PRODUCT_VARIANT_ID}"], [data-variant-id="${gift.PRODUCT_VARIANT_ID}"]`).forEach(el => {
        const row = el.closest('.cart-item, .cart__row, [data-cart-item], .cart-row');
        if (row) {
          const selectors = ['.quantity', '.cart-item__quantity', '.product-quantity', 'cart-quantity', '.ajaxcart__qty', '.qty-input'];
          selectors.forEach(s => {
            const q = row.querySelector(s);
            if (q) q.style.display = 'none';
          });
        }
      });
    });
  }

  const debouncedCheck = () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(checkCart, CONFIG.OPTIMIZATION.DEBOUNCE_DELAY);
  };

  // --- INTERCEPTAÇÃO DE REQUISIÇÕES (Ponto chave para "Automaticidade") ---
  
  // Interceptar Fetch (usado por temas modernos)
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      if (response.url.includes('/cart/add') || response.url.includes('/cart/change') || response.url.includes('/cart/update') || response.url.includes('/cart/clear')) {
        log('Detectada alteração via Fetch API');
        debouncedCheck();
      }
      return response;
    });
  };

  // Interceptar XHR (usado por temas mais antigos/jQuery)
  const originalXHR = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        log('Detectada alteração via XHR');
        debouncedCheck();
      }
    });
    return originalXHR.apply(this, arguments);
  };

  // --- OBSERVADORES E EVENTOS ---

  const observer = new MutationObserver(mutations => {
    if (isInCooldown()) return;
    const hasChange = mutations.some(m => m.addedNodes.length || m.removedNodes.length);
    if (hasChange) {
        hideGiftQuantities();
        debouncedCheck();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Eventos de clique em botões de remoção ou alteração de quantidade
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target.closest('[href*="/cart/change"], .cart__remove, .cart-item__remove, .qty-btn, .quantity__button')) {
      debouncedCheck();
    }
  });

  // Inicialização
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', debouncedCheck);
  } else {
    debouncedCheck();
  }

  window.addEventListener('focus', debouncedCheck);

})();
